import React from "react";

import { SentinelInfoSection } from "./sentinel-info-section";

export const SentinelOnboardingPageInfoSection = () => (
  <SentinelInfoSection header="Onboarding Page">
    <div>
      <p>
        On this page you will be able to onboard your team to Dependency Sentinel base on <b>Team name</b>.
      </p>
    </div>
  </SentinelInfoSection>
);